import React, { useEffect, useState } from "react";
import SwapText from "../SwapText";
import { ANALYZING_CYCLE_MS, ANALYZING_LABELS } from "../constants";
import { Pill } from "./styles";

/**
 * Striped "analyzing upload" tag to show when processing mp3 uploaded for similarity search
 */
const AnalyzingPill = ({ fill = false }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setIndex(prev => (prev + 1) % ANALYZING_LABELS.length);
    }, ANALYZING_CYCLE_MS);

    return () => clearInterval(id);
  }, []);

  return (
    <Pill $fill={fill} aria-live="polite">
      <SwapText swapKey={`analyzing-${index}`} align="center">
        {ANALYZING_LABELS[index]}
      </SwapText>
    </Pill>
  );
};

export default AnalyzingPill;
